import { FC } from "react";
import { Heading, Text } from "@otrium/atoms";
import { t, Trans } from "@lingui/macro";
import { RadioButton } from "src/atoms/Radio";
import { CTPrice } from "src/atoms/CTPrice";
import { Dropdown } from "src/atoms/DropDown";
import { Money } from "src/types/ctgraphql.d";
import { Pudo } from "src/types/graphql.d";
import { useTheme, Theme } from "@emotion/react";
import { useLingui } from "@lingui/react";
import { Label } from "src/atoms/Label";
import {
  PudoSelectionContainer,
  ShippingMethodItem,
  ShippingMethodLabel,
} from "./ShippingMethods.styled";
import classNames from "classnames";

const ShippingMethod: FC<{
  selected: boolean;
  keyValue: string | null | undefined;
  name: string;
  description?: string | null;
  price: Money | undefined;
  pudos: Pudo[] | undefined | null;
  pudoValue?: string;
  pudoDisabled: boolean;
  onChangePudo?: (value: string) => void;
  disabled: boolean;
  onChange: () => void;
}> = ({
  selected,
  keyValue,
  name,
  description,
  price,
  pudos,
  pudoValue,
  pudoDisabled,
  onChangePudo,
  disabled,
  onChange,
}) => {
  const { i18n } = useLingui();
  const theme: Theme = useTheme();

  const isPudo = keyValue === "pudo-shipping";
  const preparedPudos = pudos?.map(({ name: pudoName, value }) => ({
    key: pudoName,
    text: pudoName,
    value,
  }));

  return (
    <>
      <ShippingMethodItem
        className={classNames({ ["selected"]: selected, ["pudo"]: isPudo })}
        onClick={onChange}
      >
        <div className="info">
          <RadioButton
            type="radio"
            checked={selected}
            disabled={disabled}
            onChange={onChange}
          />
          <div className="content">
            <span className="label">
              {name}
              {" · "}
              {price ? <CTPrice price={price} /> : <Trans>Free</Trans>}
            </span>

            {description ? (
              <Text color="tone.anthraciteLight" fontSize={0}>
                {description}
              </Text>
            ) : null}
          </div>
        </div>

        {isPudo ? (
          <ShippingMethodLabel>
            <Label
              value={`${t(i18n)`Popular`}`}
              type="popular"
              textColor={theme.colors.tone.white}
              color={theme.colors.tone.white}
              backgroundColor={theme.colors.primary.goldDark}
            />
          </ShippingMethodLabel>
        ) : null}
      </ShippingMethodItem>
      {isPudo && preparedPudos && onChangePudo && selected ? (
        <PudoSelectionContainer>
          <Heading as="h4" variant="h4">
            <Trans>Nearby locations</Trans>
          </Heading>

          <Dropdown
            placeholder={`${t(i18n)`Select location`}`}
            value={pudoValue}
            options={preparedPudos}
            disabled={pudoDisabled}
            onChange={(
              _event: React.SyntheticEvent<HTMLElement>,
              { value }: { value: string }
            ) => {
              void onChangePudo(value);
            }}
          />
        </PudoSelectionContainer>
      ) : null}
    </>
  );
};

export { ShippingMethod };
